import { render, staticRenderFns } from "./imgnavigation.vue?vue&type=template&id=351d7750&scoped=true"
import script from "./imgnavigation.vue?vue&type=script&lang=ts"
export * from "./imgnavigation.vue?vue&type=script&lang=ts"
import style0 from "./imgnavigation.vue?vue&type=style&index=0&id=351d7750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d7750",
  null
  
)

export default component.exports